module.exports = __webpack_public_path__ + "static/media/logo-invert.00a7d72f.png";